import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
    selector: 'search-sidebar',
    template: ``,
    styleUrls: ['./search-sidebar.scss'],
    standalone: false
})
export class SearchSideBarComponentGeneric implements OnInit {

    @Output() hideSearchEvent: EventEmitter<any> = new EventEmitter();

    constructor() {}

    ngOnInit() {}

    hideSearch() {
        this.hideSearchEvent.emit(true);
    }

}
